import { FC } from 'react';
import { Case, Switch } from '@edikk-edikk/if';
import { Whatsapp } from '@edikk-edikk/icon/messenger/Whatsapp';
import { Instagram } from '@edikk-edikk/icon/messenger/Instagram';
import { Telegram } from '@edikk-edikk/icon/messenger/Telegram';
import { Fansly } from '@edikk-edikk/icon/messenger/Fansly';
import { Twitch } from '@edikk-edikk/icon/messenger/Twitch';
import { OnlyFans } from '@edikk-edikk/icon/messenger/OnlyFans';
import { XTwitter } from '@edikk-edikk/icon/messenger/XTwitter';
import { Signal } from '@edikk-edikk/icon/messenger/Signal';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { SocialLinkAlias } from './objects';

type PropsType = {
  alias: string;
};

const AdvertSocialLinkIcon: FC<PropsType> = ({
  alias,
}) => (
  <Switch>
    <Case condition={alias === SocialLinkAlias.whatsApp}>
      <SvgIcon Component={Whatsapp} width={25} height={25} />
    </Case>
    <Case condition={alias === SocialLinkAlias.instagram}>
      <SvgIcon Component={Instagram} width={27} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.telegram}>
      <SvgIcon Component={Telegram} width={20} height={17} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.twitch}>
      <SvgIcon Component={Twitch} width={23} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.fansly}>
      <SvgIcon Component={Fansly} width={30} height={25} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.onlyFans}>
      <SvgIcon Component={OnlyFans} width={27} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.xTwitter}>
      <SvgIcon Component={XTwitter} width={23} height={23} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.signal}>
      <SvgIcon Component={Signal} width={27} height={27} isWithoutFill />
    </Case>
  </Switch>
);

export { AdvertSocialLinkIcon };
